module.exports = __webpack_public_path__ + "static/empty-states-ctas-dont-9e3a094fa89ec2fe267a3b5d2f78e9f2.png";